import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useEffect } from "react";
import { getSourceEventParams, useAmplitude } from "@crehana/analytics";
import { useTranslation } from "@crehana/i18n";
import { useIsClient } from "@crehana/react-hooks";
import { getQueryParam } from "@crehana/utils";
import { clsx } from "clsx";
import { SignupForm } from "./components/SignupForm";
import { SocialAuthButtons } from "./components/SocialAuthButtons";
import { getNextUrl, redirectWithQueryParams } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Signup = function Signup(_ref) {
  var hideFacebookButton = _ref.hideFacebookButton,
    hideFacebookLink = _ref.hideFacebookLink,
    onSuccessProp = _ref.onSuccess,
    referFriendId = _ref.referFriendId,
    defaultEmail = _ref.defaultEmail,
    _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? true : _ref$isDark,
    nextUrlProp = _ref.nextUrl,
    _ref$shouldHideTitle = _ref.shouldHideTitle,
    shouldHideTitle = _ref$shouldHideTitle === void 0 ? false : _ref$shouldHideTitle,
    _ref$canShowPhoneInpu = _ref.canShowPhoneInput,
    canShowPhoneInput = _ref$canShowPhoneInpu === void 0 ? false : _ref$canShowPhoneInpu,
    _ref$shouldRenderLogi = _ref.shouldRenderLoginSwitcher,
    shouldRenderLoginSwitcher = _ref$shouldRenderLogi === void 0 ? true : _ref$shouldRenderLogi;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var nextUrl = nextUrlProp || getNextUrl();
  var isClient = useIsClient();
  var friendInvitationId = getQueryParam('friend_invitation_id');
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    logEvent({
      event: 'Render Signup',
      data: _objectSpread(_objectSpread({}, getSourceEventParams()), {}, {
        Type: 'URL'
      })
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onSuccessSocialAuth = function onSuccessSocialAuth(_ref2) {
    var redirect = _ref2.redirect,
      isNewUser = _ref2.isNewUser;
    if (isNewUser) {
      if (friendInvitationId) {
        window.location.href = '/premium/';
      } else {
        window.location.href = '/registro-extra/';
        return;
      }
    }
    window.location.href = redirect || '/home/';
  };
  var onSuccess = function onSuccess(_ref3) {
    var redirect = _ref3.redirect,
      user = _ref3.user;
    if (onSuccessProp) {
      onSuccessProp({
        user: user,
        redirect: redirect,
        isNewUser: true
      });
    } else {
      window.location.href = redirect;
    }
  };
  var toggleView = function toggleView() {
    redirectWithQueryParams('/entrar/');
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [!shouldHideTitle && /*#__PURE__*/_jsxs("div", {
      className: "mb-32 text-center",
      children: [/*#__PURE__*/_jsx("h2", {
        className: clsx('font-h2', {
          'text-white': isDark
        }),
        children: t('JOIN_CREHANA', 'Únete hoy')
      }), /*#__PURE__*/_jsx("h3", {
        className: clsx('text-center font-body3', {
          'text-white': isDark
        }),
        children: t('LIVE_EXPERIENCE_CREHANA', 'Empieza tu camino de aprendizaje')
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        maxWidth: 320,
        margin: 'auto'
      },
      children: [isClient && /*#__PURE__*/_jsx(SocialAuthButtons, {
        friendInvitationId: friendInvitationId,
        hideFacebookLink: hideFacebookLink,
        hideFacebookButton: hideFacebookButton,
        nextUrl: nextUrl,
        referFriendId: referFriendId,
        onSuccess: onSuccessSocialAuth,
        authType: "signUp"
      }), /*#__PURE__*/_jsx(SignupForm, {
        onSuccess: onSuccess,
        defaultEmail: defaultEmail,
        isDark: isDark,
        nextUrl: nextUrl,
        canShowPhoneInput: canShowPhoneInput
      }), shouldRenderLoginSwitcher && /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-center mt-32",
        children: [/*#__PURE__*/_jsx("span", {
          className: clsx('block mr-12 text-white font-body4', {
            'text-white': isDark
          }),
          children: t('DO_YOU_HAVE_A_ACCOUNT', {
            defaultValue: '¿Ya tienes una cuenta?'
          })
        }), ' ', /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: toggleView,
          children: /*#__PURE__*/_jsx("span", {
            className: "tw-font-semibold text-green-main font-body4",
            children: t('SIGN_IN', {
              defaultValue: 'Inicia sesión'
            })
          })
        })]
      })]
    })]
  });
};
export default Signup;